import { DocumentTypeHandler } from "../common/commonDomain";
import { applyForm, SubscriptionForm, SubscriptionFormForm } from "./subscriptionFormDomain";
import { DocumentType } from "../../common/documents";
import { noop } from "lodash";

export const subscriptionFormHandler: DocumentTypeHandler<
  DocumentType.subscription_form,
  SubscriptionForm,
  SubscriptionFormForm
> = {
  type: DocumentType.subscription_form,
  initNewForm: (dispatch, context) => new SubscriptionFormForm(dispatch, context),
  initForm: noop,
  applyForm: (form) => applyForm(form),
};
